<template>
    <div class="payment__form">
        <form
            v-if="
                state.currentView == 'MOMO_UGANDA_INIT_VIEW' &&
                    state.processing == false
            "
            @submit.prevent="checkPhone"
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{$t("mm.init.instruction")}}
            </h5>
            <primary-input
                type="tel"
                :title="$t('mm.input.phone')"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone"
                placeholder="07013926478"
                @value-change="telephone = $event"
                :defaultValue="getValueFromPath(state, 'inputs.phone.value') || null"
                :isRequired="getValueFromPath(state, 'inputs.phone.required') || true"
                inputName="phone"
                :number-only="true"
            />
            <PrimaryButton
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                type="submit"
            />
        </form>
        <div
            v-else-if="
                state.currentView == 'REDIRECT_VIEW' && state.processing != true
            "
        >
            <div class="redirect-wrapper">
                <div class="redirect-icon--arrow">
                    <svg width="33" height="27" viewBox="0 0 33 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.1799 3.13007L18.5799 7.10007L24.7999 6.47007L13.2599 20.5301L4.15988 13.1301L1.62988 16.2201L13.8299 26.1301L27.9799 8.89007L28.6199 15.2501L32.5999 14.8501L31.2799 1.82007L18.1799 3.13007Z" fill="#FFCA7D"/>
                        <path d="M17.0998 1.51996L17.4998 5.47996L23.7098 4.85996L12.1798 18.91L3.0898 11.52L0.549805 14.61L12.7498 24.52L26.8998 7.27996L27.5398 13.64L31.5198 13.24L30.1998 0.209961L17.0998 1.51996Z" fill="black"/>
                        <path d="M0.549805 14.61L1.6298 16.22L13.8298 26.13L12.7498 24.52L0.549805 14.61Z" fill="#703E00"/>
                        <path d="M17.5 5.47998L18.58 7.09999L22.18 6.72998L23.71 4.85999L17.5 5.47998Z" fill="#703E00"/>
                        <path d="M27.54 13.64L28.62 15.25L32.6 14.85L31.52 13.24L27.54 13.64Z" fill="#FFCA7D"/>
                        <path d="M30.1997 0.209961L31.2797 1.81996L32.5997 14.85L31.5197 13.24L30.1997 0.209961Z" fill="#703E00"/>
                    </svg>
                </div>
            </div>
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{$t("mm.redirect.instruction")}}
            </p>
            <PrimaryButton :content="$t('ui.redirect.btn')" @click="Next" />
        </div>
        <div
            v-else-if="
                checkoutData.view.current == 'MOMO_UGANDA_CONFIRM_VIEW' &&
                    checkoutData.processing != true
            "
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{$t("mm.notification.message")}}
            </h5>
            <div class="loader-container">
                <div class="loader-wrapper">
                    <div class="loader-icon"></div>
                </div>
            </div>
            <p class="payment__instruction--refresh">{{$t("ui.transaction.refresh")}}.</p>
        </div>
    </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { getValueFromPath } from "@/support/helpers";

import PrimaryButton from "@/components/form/base-button";
import PrimaryInput from "@/components/form/base-input";
import { injectStore, mapState } from "redux-vuex";
import { ref, onBeforeUnmount, watch } from "vue";
import { isValidPhoneNumber } from "../../support/helpers";

export default {
    name: "MobileMoneyUganda",
    components: {
        PrimaryInput,
        PrimaryButton,
    },
    setup(_, { emit }) {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const network = ref("");
        const telephone = ref("");
        const transactionSuccessful = ref(false);
        const momoError = ref(false);
        const errorMessage = ref("");
        const { t } = useI18n();

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function checkPhone() {
            if (telephone.value != "") {
                let trimmedPhoneNumber = telephone.value.replace(/\s/g, "").replace(/[()]/g, "");

                if (isValidPhoneNumber(trimmedPhoneNumber)) {
                    momoError.value = `true-${new Date().getTime()}`;
                    errorMessage.value = "";
                    telephone.value = trimmedPhoneNumber;
                    step2();
                } 
                else {
                    momoError.value = `true-${new Date().getTime()}`;
                    errorMessage.value = t("mm.invalid.phonenumber");
                }
            }
        }

        function step2() {
            const data = { phone: telephone.value };
            checkoutData.value.view.context.$actions.update(data);
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }

        watch(momoError, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                emit("momo-error", errorMessage.value);
            }
        });

        watch(() => checkoutData.value, (newData) => {
            if (newData) {
                momoError.value = false;
            }
        });

        onBeforeUnmount(() => {
            momoError.value = false;
            errorMessage.value = "";
            subscription();
        });
        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                defaultNetwork: (state) =>
                    getValueFromPath(state, "view.context.inputs.network.value"),
                networks: (state) =>
                    getValueFromPath(state, "view.context.inputs.network.options") || [],
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            checkoutData,
            network,
            getValueFromPath,
            telephone,
            transactionSuccessful,
            checkPhone,
            step2,
            Next,
        };
    },
};
</script>

<style scoped>
</style>